import { BidsHeader } from '../models/bids-header';

export const browseBidsHeaders: BidsHeader[] = [
  { SearchItem: 'BidDate', title: 'Bid Date', IsReversed: true, IsDefault: true, Size: 2 },
  { SearchItem: 'State', title: 'State', IsReversed: false, IsDefault: false, Size: 1 },
  { SearchItem: 'County', title: 'County', IsReversed: false, IsDefault: false, Size: 2 },
  { SearchItem: 'Name', title: 'Name', IsReversed: false, IsDefault: false, Size: 6 },
  { SearchItem: 'IsBid', title: '', IsReversed: false, IsDefault: false, Size: 1 }
];
